






































import query_sql from "@/views/query/querySql.vue";
import axios from 'axios'
import {Component, Vue} from "vue-property-decorator";

@Component({components: {query_sql}})
export default class multiSource extends Vue {
    focus = '';
    addSnippet = {
        title: '',
        text: ''
    };
    openSnippet = false;
    openSource = false;
    idc = '';
    fetchData = {
        source: []
    };
    sourceList = [] as any;
    $config:any;

    deferReply() {
        axios.delete(`${this.$config.url}/query/undo`)
            .then(res => this.$config.notice(res.data))
            .catch(err => this.$config.err_notice(this, err));
        this.$router.push({
            name: 'query'
        })
    }

    addsnip() {
        if (this.$store.state.snippet === null) {
            this.$store.state.snippet = []
        }
        for (let i of this.$store.state.snippet) {
            if (i.title === this.addSnippet.title) {
                this.$Message.error('snippet标签名不得重复!');
                return
            }
        }
        if (this.$store.state.snippet.length > 14) {
            this.$Message.error('snippet最多保存15个!');
            return
        }
        this.$store.commit('snippetTag', this.addSnippet)
        this.$Message.success('snippet已保存!');
    }

    opensnip() {
        this.openSnippet = true
    }

    handleTabRemove(name:any) {
        let idx = this.sourceList.indexOf(name);
        this.sourceList.splice(idx, 1);
    }

    openModel() {
        this.openSource = true;
        this.fetchSource()

    }

    choiceSource(vl:string) {
        for (let i of this.sourceList) {
            if (i === vl) {
                this.$Message.warning('不可重复打开相同数据源！');
                return
            }
        }
        this.sourceList.push(vl);
        this.openSource = false;
        this.focus = vl
    }

    fetchSource() {
        axios.get(`${this.$config.url}/fetch/source/${this.idc}/query`)
            .then(res => {
                if (res.data.x === 'query') {
                    this.fetchData.source = res.data.source;
                } else {
                    this.$config.notice('非法劫持参数！')
                }
            })
            .catch(error => {
                this.$config.err_notice(this, error)
            })
    }

    mounted() {
        axios.put(`${this.$config.url}/query/status`)
            .then(res => {
                if (res.data.status !== 1) {
                    this.$router.push({
                        name: 'query'
                    });
                } else {
                    this.idc = res.data.idc;
                    this.openModel()
                }

            })
            .catch(err => this.$config.err_notice(this, err))
    }
}
